export default {"src":"/_next/static/media/File.05f9561c.svg","height":80,"width":82,"blurWidth":0,"blurHeight":0};